import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Role } from '../utils/Enums/Roles';

interface RequiredPermissionsParams {
    requiredPermissions: Role[];
    children: JSX.Element | JSX.Element[];
    forbiddenAccess?: Role[];
}

export const RequiredPermissions = ({ requiredPermissions, children, forbiddenAccess }: RequiredPermissionsParams): JSX.Element => {
    const { hasPermission } = useContext(AuthContext);
    if (forbiddenAccess && hasPermission(forbiddenAccess)) return <></>;
    return hasPermission(requiredPermissions) ? <>{children}</> : <></>;
};
